/* eslint-disable */
// <defs><style>.cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#linear-gradient-9);}.cls-10{fill:url(#linear-gradient-10);}.cls-11{fill:url(#linear-gradient-11);}.cls-12{fill:url(#linear-gradient-12);}.cls-13{fill:url(#linear-gradient-13);}.cls-14{fill:url(#linear-gradient-14);}.cls-15{fill:url(#linear-gradient-15);}.cls-16{fill:url(#linear-gradient-16);}.cls-17{fill:url(#linear-gradient-17);}.cls-18{fill:url(#linear-gradient-18);}.cls-19{fill:url(#linear-gradient-19);}.cls-20{fill:url(#linear-gradient-20);}.cls-21{fill:url(#linear-gradient-21);}.cls-22{fill:url(#linear-gradient-22);}</style>
import React, { Component } from 'react'


import Svg, {
    Circle,
    Ellipse,
    G,
    LinearGradient,
    RadialGradient,
    Line,
    Path,
    Polygon,
    Polyline,
    Rect,
    Symbol,

    Use,
    Defs,
    Stop
} from 'react-native-svg';
export const SvgLocationCalloutX = ({ size }) => {
    return (
        <Svg width={size} height={size} viewBox="0 0 15 15">
            <G fill="none" fillRule="evenodd" opacity=".5">
                <Circle cx="7.5" cy="7.5" r="7.5" fill="#FFFFFF" />
                <Rect width="1.667" height="10.833" x="6.919" y="2.336" fill="#4F576A" transform="rotate(45 7.753 7.753)" rx=".833" />
                <Rect width="1.667" height="10.833" x="6.919" y="2.336" fill="#4F576A" transform="rotate(-45 7.753 7.753)" rx=".833" />
            </G>
        </Svg>

    )
}

